module.exports = __webpack_public_path__ + "img/content1.3bb750c4.png";